import React from "react";
import StarsIcon from "@mui/icons-material/Stars";
import { Typography, useTheme } from "@mui/material";
import { CustomThemeOptions } from "../../CustomColors/Colors";

const UserStatus = ({ mentor }: any) => {
    const theme: CustomThemeOptions = useTheme();
    if (!mentor) return <></>;

    return (
        <div
            style={{
                display: "flex",
                border: `1px solid ${theme.palette.mentor.main}`,
                borderRadius: "12px",
                padding: ".125rem",
            }}
        >
            <StarsIcon
                fontSize="small"
                sx={{
                    color: theme.palette.mentor.main,
                }}
            />
            <Typography
                variant="caption"
                sx={{
                    color: theme.palette.mentor.main,
                }}
                fontWeight={600}
            >
                &emsp;{mentor}
            </Typography>
        </div>
    );
};

export default UserStatus;
